import { apiPost } from '../api';
import { ApiNames, ApiPath } from '../enums';

export async function getUserContract(): Promise<{ url: string }> {
  return apiPost<{ url: string }>(ApiNames.MonorepoApiEndpoint, ApiPath.GetSignedUserContract, undefined, true);
}
